/* Rydr theme — lightweight interactions (no dependencies) */
(function () {
  'use strict';

  /* ---- Mobile nav toggle ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (nav) nav.classList.toggle('is-open');
  });

  /* ---- Hero carousel ---- */
  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.hero__dot'));
    if (slides.length <= 1) return;

    var current = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
    var timer = null;

    function go(idx) {
      current = (idx + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    function start() { if (autoplay) timer = setInterval(function () { go(current + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); }

    root.querySelectorAll('[data-hero-prev]').forEach(function (b) {
      b.addEventListener('click', function () { stop(); go(current - 1); start(); });
    });
    root.querySelectorAll('[data-hero-next]').forEach(function (b) {
      b.addEventListener('click', function () { stop(); go(current + 1); start(); });
    });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { stop(); go(i); start(); });
    });

    // Touch swipe (mobile)
    var touchX = null;
    root.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) { stop(); go(current + (dx < 0 ? 1 : -1)); start(); }
      touchX = null;
    }, { passive: true });

    go(0);
    start();
  }

  document.querySelectorAll('[data-hero]').forEach(initHero);

  /* ---- Testimonials pager ---- */
  document.querySelectorAll('[data-testimonials]').forEach(function (root) {
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 3;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.review-card'));
    var prev = root.querySelector('[data-reviews-prev]');
    var next = root.querySelector('[data-reviews-next]');
    var counter = root.querySelector('[data-reviews-counter]');
    if (cards.length <= perPage) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      if (counter) counter.style.display = 'none';
      return;
    }
    var page = 0;
    var totalPages = Math.ceil(cards.length / perPage);
    function render() {
      cards.forEach(function (c, i) {
        var p = Math.floor(i / perPage);
        c.style.display = p === page ? '' : 'none';
      });
      if (counter) counter.textContent = (page + 1) + ' / ' + totalPages;
      if (prev) prev.disabled = page === 0;
      if (next) next.disabled = page === totalPages - 1;
    }
    if (prev) prev.addEventListener('click', function () { page = Math.max(0, page - 1); render(); });
    if (next) next.addEventListener('click', function () { page = Math.min(totalPages - 1, page + 1); render(); });
    render();
  });

  /* ---- Product page: gallery + variant switching ---- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var mainImg = root.querySelector('[data-main-image]');
    var thumbs  = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));

    function activateThumb(thumb) {
      if (!thumb) return;
      var full = thumb.getAttribute('data-full');
      if (full && mainImg) mainImg.src = full;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    }
    function thumbByMedia(mediaId) {
      return thumbs.filter(function (t) { return t.getAttribute('data-media-id') == mediaId; })[0];
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { activateThumb(t); }); });

    var dataEl  = root.querySelector('[data-product-variants]');
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
    if (!dataEl || !selects.length) return; // single-variant product: gallery only

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn  = root.querySelector('[data-add]');

    function selectedValues() { return selects.map(function (s) { return s.value; }); }
    function findVariant(values) {
      return variants.filter(function (v) {
        return v.options.length === values.length &&
               v.options.every(function (o, i) { return o === values[i]; });
      })[0];
    }
    function update() {
      var v = findVariant(selectedValues());
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable-text'); }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.compareAt ? v.price + ' <s>' + v.compareAt + '</s>' : v.price;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available
          ? addBtn.getAttribute('data-add-text')
          : addBtn.getAttribute('data-soldout-text');
      }
      activateThumb(thumbByMedia(v.mediaId));
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });
})();
